package com.bikompanion.ui.strings

val EnBikompanionStrings = object : BikompanionStrings {
    override val actionRetry = "Retry"
    override val actionClose = "Close"
    override val actionSubmit = "Submit"
    override val detailsLabel = "Details"
    override val detailsShow = "Show details"
    override val detailsHide = "Hide details"
    override val actionGetDirections = "Get directions"
    override val actionShareStation = "Share station"
    override val linkCopied = "Link copied"
    override val locateShow = "Show my location"
    override val locateFollowHeading = "Follow my heading"
    override val locateStopFollowing = "Stop following me"
    override val settingsTitle = "Settings"
    override val actionBack = "Back"
    override val settingsAppearance = "Appearance"
    override val settingsLanguage = "Language"
    override val languageSystem = "System default"
    override val themeSystem = "System"
    override val themeLight = "Light"
    override val themeDark = "Dark"
    override val settingsNotifications = "Notifications"
    override val stationAlerts = "Station alerts"
    override val notificationsOn = "On: you'll hear when a watched station has a bike"
    override val notificationsOff = "Off: watched stations can't alert you"
    override val notificationsBlocked = "Blocked: allow notifications in your browser's site settings"
    override val actionManage = "Manage"
    override val actionTurnOn = "Turn on"
    override val settingsSupport = "Support"
    override val sendFeedback = "Send feedback"
    override val sendFeedbackDescription = "Tell us about a problem or wrong station data"
    override val shareApp = "Share the app"
    override val settingsAbout = "About"
    override val aboutApp = "About Bikompanion"
    override val aboutDevelopedBy = "Developed by Tiago Araujo"
    override val aboutDataSources = "Data sources"
    override val sourceCityBikesDescription = "Bike-share networks worldwide"
    override val sourceGbfsTitle = "GBFS operator feeds"
    override val sourceGbfsDescription = "Live station data from bike-share operators"
    override val sourceOsmTitle = "OpenStreetMap contributors"
    override val sourceOsmDescription = "Bike parking and map data"
    override val sourceCartoDescription = "Map tiles"
    override val aboutLegal = "Legal"
    override val licensesTitle = "Open source licenses"
    override val privacyPolicy = "Privacy policy"
    override val deleteRatings = "Delete my ratings"
    override val deleteRatingsDescription = "Emails us your anonymous ID so we can delete them"
    override val licensesLoadFailed = "Couldn't load the license list"
    override val aboutVersion = { version: String -> "Version $version" }
    override val issueFlatTire = "Flat tire"
    override val issueFrontBrake = "Front brake not working"
    override val issueRearBrake = "Rear brake not working"
    override val issueChain = "Chain slipping"
    override val issueGears = "Gears not shifting"
    override val issueSeat = "Seat damaged or missing"
    override val issueLights = "Lights not working"
    override val issueLockOrBasket = "Lock or basket damaged"
    override val issueFrame = "Frame damage"
    override val issueMotor = "Electric motor not working"
    override val issueBattery = "Battery not charging"
    override val issueOther = "Other"
    override val networksLoadFailed = "Couldn't load bike networks. Check your connection."
    override val parkingLoadFailed = "Couldn't load bike parking"
    override val parkingLoading = "Finding bike parking…"
    override val stationsLoading = "Loading bike stations…"
    override val noNetworkHereTitle = "No bike share here"
    override val noNetworkHereHint = "Zoom out to find the nearest network"
    override val installTitle = "Install Bikompanion"
    override val installHintIos = "Tap Share, then Add to Home Screen."
    override val installHintAndroid = "Get the app on Google Play."
    override val actionInstall = "Install"
    override val parkingTypeStands = "Bike Stands"
    override val parkingTypeShed = "Bike Shed"
    override val parkingTypeLockers = "Bike Lockers"
    override val parkingTypeBuilding = "Bike Building"
    override val parkingTypeOther = "Bike Parking"
    override val fieldAddress = "Address"
    override val fieldCovered = "Covered"
    override val fieldYes = "Yes"
    override val fieldNo = "No"
    override val fieldId = "ID"
    override val fieldStationId = "Station ID"
    override val fieldCoordinates = "Coordinates"
    override val fieldCapacity = "Capacity"
    override val fieldNetwork = "Network"
    override val fieldName = "Name"
    override val fieldCity = "City"
    override val fieldCountry = "Country"
    override val fieldCompany = "Company"
    override val fieldLicense = "License"
    override val fieldLicenseUrl = "License URL"
    override val availabilityBikes = "Bikes"
    override val availabilityElectric = "Electric"
    override val availabilityEmpty = "Empty"
    override val bicingNextPickup = { p0: String -> "Next Bicing pickup in $p0" }
    override val rateTitle = "Check or rate a bike"
    override val rateFindingNetworks = "Looking for the bike networks around you…"
    override val rateWhatsWrong = "What's wrong with it?"
    override val rateBikeNumber = "Bike number"
    override val rateElectricBike = "Electric bike"
    override val rateVoteBad = "Bad"
    override val rateVoteGood = "Good"
    override val rateWhichNetwork = "Which network is this bike from?"
    override val refreshRateLimited = "Request limit reached — retrying automatically"
    override val refreshFailed = "Couldn't update"
    override val refreshNextUpdate = { p0: Int -> "Next update in ${p0}s" }
    override val refreshUpdating = "Updating…"
    override val dataNone = "No data yet"
    override val dataAgeJustNow = "Showing data from just now"
    override val dataAgeMinutes = { p0: Int -> "Showing data from $p0 min ago" }
    override val dataAgeHours = { p0: Int -> "Showing data from $p0 h ago" }
    override val dataAgeDays = { p0: Int -> "Showing data from $p0 d ago" }
    override val actionOpenOperator = { p0: String -> "Open $p0" }
    override val watchNormal = "Watch for normal bikes"
    override val watchElectric = "Watch for electric bikes"
    override val watchInstallNormal = "Install the app to watch for normal bikes"
    override val watchInstallElectric = "Install the app to watch for electric bikes"
    override val watchStopNormal = "Stop watching normal bikes"
    override val watchStopElectric = "Stop watching electric bikes"
    override val actionCheckRateBike = "Check / Rate Bike"
    override val layerStations = "Stations"
    override val layerParking = "Bike Parking"
    override val mapLabelBikes = { p0: Int -> "$p0 bikes" }
    override val mapLabelEbikes = { p0: Int -> "$p0 e-bikes" }
    override val mapLabelFree = { p0: Int -> "$p0 free" }
    override val scoreHeadline = { p0: String, p1: String -> "Bike $p0 · $p1" }
    override val scoreNoRatings = "No ratings yet — you'd be the first."
    override val scoreLooksGood = "Looks good."
    override val scoreHasProblems = "Riders have had problems with this one."
    override val scoreMixed = "Mixed reviews."
    override val ratingNetworkRequired = "Pick which network this bike belongs to first."
    override val ratingThanks = { p0: String -> "Thanks for rating bike $p0!" }
    override val ratingCooldown = { p0: Int -> "You already rated this bike recently. Try again in ${p0}m." }
    override val ratingQueued = "Saved — we will send it once you are back online."
    override val ratingInvalidBike = "That bike number is not valid for this network."
    override val ratingRejected = "Could not save that rating. Please try again later."
    override val notificationFoundTitle = "Bike available"
    override val notificationFoundNormal = { p0: String -> "Normal bike available at $p0" }
    override val notificationFoundElectric = { p0: String -> "Electric bike available at $p0" }
    override val notificationExpiredTitle = "Station watch ended"
    override val notificationExpiredNormal = { p0: String -> "Stopped watching for normal bikes at $p0 after 30 minutes" }
    override val notificationExpiredElectric = { p0: String -> "Stopped watching for electric bikes at $p0 after 30 minutes" }
    override val channelWatchAlertsName = "Station watch alerts"
    override val channelWatchAlertsDescription = "Bike availability and station watch updates"
    override val channelBackgroundWatchName = "Background station watch"
    override val notificationWatchingTitle = "Watching bike stations"
    override val notificationWatchingText = "Monitoring watched stations in the background"
    override val scoreFewRatings = { count: Int -> singularOrPlural(count, "Only $count rating so far.", "Only $count ratings so far.") }
    override val scorePositiveRides = { percent: Int, count: Int ->
        singularOrPlural(
            count,
            "$percent% positive over the last $count ride",
            "$percent% positive over the last $count rides",
        )
    }
}
